export const ResourcesTrackingCategory: string = 'Resources';
